import * as moment from 'moment';

import { Child, ChildPersona, ChildPersonaType } from '../../types/family';

enum ArithmeticAbility {
  ARITHMETIC_NO_BASIC = 200000,
  /** 认识数字，但不会数数 */
  ARITHMETIC_KNOW_NUMBERS_NO_COUNT = 200100,
  /** 会数数，但不会加减法 */
  ARITHMETIC_KNOW_COUNT_NO_ADD_OR_SUB = 200200,
  /** 会5以内实物加法，不会5以内实物减法 */
  ARITHMETIC_KNOW_PHYSICAL_ADD_WITHIN_5_NO_SUB = 200300,

  /** 会5以内实物加减法，不会10以内实物加减法 */
  ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_5_NO_PHYSICAL_ADD_AND_SUB_WITHIN_10 = 200400,
  /** 会10以内实物加法，不会10以内实物减法 */
  ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_PHYSICAL_ADD_WITHIN_10 = 200500,

  /** 会10以内实物加减法，不会10以内抽象加减法 */
  ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_ABSTRACT_ADD_AND_SUB_WITHIN_10 = 200600,
  /** 会10以内抽象加法，不会10以内抽象减法 */
  ARITHMETIC_KNOW_ABSTRACT_ADD_WITHIN_10_NO_ABSTRACT_SUB_WITHIN_10 = 200700,

  /** 会10以内抽象加减法，不认识11~20的数 */
  ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_NO_11_TO_20 = 200800,
  /** 会10以内抽象加减法，认识11~20的数，不会20以内加减法 */
  ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_KNOW_11_TO_20_NO_ADD_AND_SUB_WITHIN_20 = 200900,

  /** 会20以内不进位加法， 不会20以内不退位减法 */
  ARITHMETIC_KNOW_NOT_CARRY_ADD_WITHIN_20_NO_NOT_BORROW_SUB_WITHIN_20 = 201000,

  /** 会20以内不退位加减法，不会进退位加减法 */
  ARITHMETIC_KNOW_NOT_CARRY_BORROW_ADD_AND_SUB_WITHIN_20_NO_CARRY_BORROW_ADD_AND_SUB = 201100,

  /** 会 20以内进位加法，不会20以内退位减法 */
  ARITHMETIC_KNOW_CARRY_ADD_WITHIN_20_NO_BORROW_SUB_WITHIN_20 = 201200,
  /** 会20以内进退加减法 */
  ARITHMETIC_KNOW_CARRY_BORROW_ADD_AND_SUB_WITHIN_20 = 201300,
}

const CHILD_ABILITY_DESCRIPTIONS = {
  // Math
  [ArithmeticAbility.ARITHMETIC_NO_BASIC]: '零基础',
  [ArithmeticAbility.ARITHMETIC_KNOW_NUMBERS_NO_COUNT]: '认识数字，但不会数数',
  [ArithmeticAbility.ARITHMETIC_KNOW_COUNT_NO_ADD_OR_SUB]: '会数数，但不会加减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_WITHIN_5_NO_SUB]: '会5以内实物加法，不会5以内实物减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_5_NO_PHYSICAL_ADD_AND_SUB_WITHIN_10]:
    '会5以内实物加减法，不会10以内实物加减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_PHYSICAL_ADD_WITHIN_10]:
    '会10以内实物加法，不会10以内实物减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_ABSTRACT_ADD_AND_SUB_WITHIN_10]:
    '会10以内实物加减法，不会10以内抽象加减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_ABSTRACT_ADD_WITHIN_10_NO_ABSTRACT_SUB_WITHIN_10]:
    '会10以内抽象加法，不会10以内抽象减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_NO_11_TO_20]: '会10以内抽象加减法，不认识11~20的数',
  [ArithmeticAbility.ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_KNOW_11_TO_20_NO_ADD_AND_SUB_WITHIN_20]:
    '会10以内抽象加减法，不认识11~20的数，不会20以内加减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_NOT_CARRY_ADD_WITHIN_20_NO_NOT_BORROW_SUB_WITHIN_20]:
    '会20以内不进位加法， 不会20以内不退位减法',

  [ArithmeticAbility.ARITHMETIC_KNOW_NOT_CARRY_BORROW_ADD_AND_SUB_WITHIN_20_NO_CARRY_BORROW_ADD_AND_SUB]:
    '会20以内不退位加减法，不会进退位加减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_CARRY_ADD_WITHIN_20_NO_BORROW_SUB_WITHIN_20]:
    '会 20以内进位加法，不会20以内退位减法',
  [ArithmeticAbility.ARITHMETIC_KNOW_CARRY_BORROW_ADD_AND_SUB_WITHIN_20]: '会20以内进退加减法',
};

export enum KnowledgeLevel {
  ZERO,
  ONE,
  TWO,
  THREE,
  FOUR,
  FIVE,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
  TEN,
  ELEVEN,
  TWELVE,
  THIRTEEN,
}
/**
 * 游戏结果到算术能力标准
 */
const KNOWLEDGE_LEVEL_ARITHMETIC_ABILITY = {
  [KnowledgeLevel.ZERO]: ArithmeticAbility.ARITHMETIC_NO_BASIC,

  [KnowledgeLevel.ONE]: ArithmeticAbility.ARITHMETIC_KNOW_NUMBERS_NO_COUNT,

  [KnowledgeLevel.TWO]: ArithmeticAbility.ARITHMETIC_KNOW_COUNT_NO_ADD_OR_SUB,

  [KnowledgeLevel.THREE]: ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_WITHIN_5_NO_SUB,

  [KnowledgeLevel.FOUR]:
    ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_5_NO_PHYSICAL_ADD_AND_SUB_WITHIN_10,

  [KnowledgeLevel.FIVE]: ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_PHYSICAL_ADD_WITHIN_10,

  [KnowledgeLevel.SIX]:
    ArithmeticAbility.ARITHMETIC_KNOW_PHYSICAL_ADD_AND_SUB_WITHIN_10_NO_ABSTRACT_ADD_AND_SUB_WITHIN_10,

  [KnowledgeLevel.SEVEN]: ArithmeticAbility.ARITHMETIC_KNOW_ABSTRACT_ADD_WITHIN_10_NO_ABSTRACT_SUB_WITHIN_10,

  [KnowledgeLevel.EIGHT]: ArithmeticAbility.ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_NO_11_TO_20,

  [KnowledgeLevel.NINE]:
    ArithmeticAbility.ARITHMETIC_KNOW_ABSTRACT_ADD_AND_SUB_WITHIN_10_KNOW_11_TO_20_NO_ADD_AND_SUB_WITHIN_20,

  [KnowledgeLevel.TEN]: ArithmeticAbility.ARITHMETIC_KNOW_NOT_CARRY_ADD_WITHIN_20_NO_NOT_BORROW_SUB_WITHIN_20,

  [KnowledgeLevel.ELEVEN]:
    ArithmeticAbility.ARITHMETIC_KNOW_NOT_CARRY_BORROW_ADD_AND_SUB_WITHIN_20_NO_CARRY_BORROW_ADD_AND_SUB,

  [KnowledgeLevel.TWELVE]: ArithmeticAbility.ARITHMETIC_KNOW_CARRY_ADD_WITHIN_20_NO_BORROW_SUB_WITHIN_20,

  [KnowledgeLevel.THIRTEEN]: ArithmeticAbility.ARITHMETIC_KNOW_CARRY_BORROW_ADD_AND_SUB_WITHIN_20,
};

function calcKnowledgeLevel(personas: ChildPersona[], quizAt: Date) {
  if (personas && personas.length > 0) {
    const quizAtAfterPersonas = personas.filter(
      persona => persona.type === ChildPersonaType.ARITHMETIC_ABILITY && moment(quizAt).isAfter(persona.createdAt),
    );
    if (quizAtAfterPersonas.length > 0) {
      const [persona] = quizAtAfterPersonas.sort((a, b) => {
        return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf();
      });
      return persona.value;
    }
  }
  return -1;
}

function getBeforeLearnKnowledgeLevel(children: Child[], quizEndAt: Date) {
  if (!quizEndAt) return '未测试';
  if (children && children.length > 0) {
    // 取最新的孩子信息
    const [child] = children.sort((a, b) => {
      return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf();
    });

    if (child && child.personas) {
      const abilityPersonas = child.personas.filter(persona => persona.type === ChildPersonaType.ARITHMETIC_ABILITY);
      // 除第一个外的知识水平为评测结果
      const knowledgeLevel = calcKnowledgeLevel(abilityPersonas.slice(1), quizEndAt);
      if (knowledgeLevel === -1) {
        return '未测试';
      }
      return CHILD_ABILITY_DESCRIPTIONS[knowledgeLevel];
    }
  }
  return '未测试';
}

function getChildAbilityFromKnowledgeLevel(knowledgeLevel: number) {
  const arithmeticAbility = KNOWLEDGE_LEVEL_ARITHMETIC_ABILITY[knowledgeLevel];
  return CHILD_ABILITY_DESCRIPTIONS[arithmeticAbility];
}

function getAfterLearnKnowledgeLevel(children: Child[], quizEndAt: Date) {
  if (!quizEndAt) return '未测试';
  if (children && children.length > 0) {
    children.sort((a, b) => {
      return moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf();
    });
    const child = children.find(child =>
      child.personas.some(persona => persona.type === ChildPersonaType.ARITHMETIC_ABILITY),
    );
    if (child && child.personas) {
      let knowledgeLevel = calcKnowledgeLevel(child.personas, quizEndAt);
      if (knowledgeLevel === -1) {
        return '未测试';
      }
      if (knowledgeLevel !== ArithmeticAbility.ARITHMETIC_KNOW_CARRY_BORROW_ADD_AND_SUB_WITHIN_20) {
        knowledgeLevel += 100;
      }
      return CHILD_ABILITY_DESCRIPTIONS[knowledgeLevel];
    }
  }
  return '未测试';
}

export { getBeforeLearnKnowledgeLevel, getAfterLearnKnowledgeLevel, getChildAbilityFromKnowledgeLevel };



// WEBPACK FOOTER //
// ./src/screens/group/CalcKnowledgeLevel.ts